import React from 'react';
import { Button } from './ui/Button';
import { Mail, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function ContactSection() {
  return <section id="contact" className="relative py-24 bg-earth-900" data-id="element-38" data-mp="2zaczhvcvvzmf">
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none mix-blend-overlay" data-id="element-39" data-mp="2kl8g4aucrpcq"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-40" data-mp="2pj05ax3m4xd8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-41" data-mp="3d9me4qlfyloa">
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-4" data-id="element-42" data-mp="387n9zehvnkqa">
            Ready to Begin Your Next Chapter?
          </h2>
          <p className="text-xl text-cream-50/70 mb-12" data-id="element-43" data-mp="1wu30nwsbqz2y">
            Let's connect. Every message is confidential.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12" data-id="element-44" data-mp="7ld56s7ksm76">
            <a href="tel:+31630303225" className="flex items-center space-x-3 text-gold-400 hover:text-white transition-colors group" data-id="element-45" data-mp="2nv4fp3ppda9">
              <div className="w-12 h-12 rounded-full bg-gold-400/10 flex items-center justify-center group-hover:bg-gold-400/20 transition-colors" data-id="element-46" data-mp="clhlah4knewv">
                <Phone size={20} data-id="element-47" data-mp="qjfy3i38v3a9" />
              </div>
              <span className="text-lg font-medium" data-id="element-48" data-mp="lm7c16ez6f3q">+31 6 30303225</span>
            </a>

            <a href="mailto:mark.vermeulen90@gmail.com" className="flex items-center space-x-3 text-gold-400 hover:text-white transition-colors group" data-id="element-49" data-mp="10au2a3654r9q">
              <div className="w-12 h-12 rounded-full bg-gold-400/10 flex items-center justify-center group-hover:bg-gold-400/20 transition-colors" data-id="element-50" data-mp="19bi6k65qfd9f">
                <Mail size={20} data-id="element-51" data-mp="14dqftfgtpx6t" />
              </div>
              <span className="text-lg font-medium" data-id="element-52" data-mp="1yznh028rnac">
                mark.vermeulen90@gmail.com
              </span>
            </a>
          </div>

          <Button variant="primary" className="text-xl px-10 py-4 shadow-lg shadow-gold-400/20" data-id="element-53" data-mp="6yvqavz7d8ob">
            Book a Free Discovery Call
          </Button>
        </motion.div>
      </div>
    </section>;
}